import api from './api';

const agentWebsiteProfileService = {
  // Get agent's website profile
  getProfile: async () => {
    try {
      const response = await api.get('/agent-website-profile/profile');
      return response.data;
    } catch (error) {
      console.error('Error fetching website profile:', error);
      throw error;
    }
  },

  // Create or update agent's website profile
  saveProfile: async (profileData) => {
    try {
      const response = await api.post('/agent-website-profile/profile', profileData);
      return response.data;
    } catch (error) {
      console.error('Error saving website profile:', error);
      throw error;
    }
  },

  // Update agent's website profile
  updateProfile: async (profileData) => {
    try {
      const response = await api.put('/agent-website-profile/profile', profileData);
      return response.data;
    } catch (error) {
      console.error('Error updating website profile:', error);
      throw error;
    }
  },

  // Upload profile photo
  uploadPhoto: async (formData) => {
    try {
      const response = await api.post('/agent-website-profile/photo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading profile photo:', error);
      throw error;
    }
  },

  // Delete agent's website profile
  deleteProfile: async () => {
    try {
      const response = await api.delete('/agent-website-profile/profile');
      return response.data;
    } catch (error) {
      console.error('Error deleting website profile:', error);
      throw error;
    }
  }
};

export default agentWebsiteProfileService;
